<template>
  <v-dialog v-model="dialog" width="360" class="d-2304" :retain-focus="false">
    <v-card style="border-radius: 8px">
      <v-card-title class="font--m-3 font-weight-bold pa-5 pb-1">
        <h3 class="mx-auto primary--text">서비스 이용이 중지되었어요.</h3>
      </v-card-title>

      <v-card-text class="font-size--14 text-center color--gray-100 line-height--14 pb-4">
        내용 확인을 위해 고객센터로 문의해 주시면,<br />
        빠르게 확인 도와드릴게요.
      </v-card-text>

      <v-card-actions class="pa-5 pt-0">
        <BasicButton
          large
          block
          depressed
          height="48"
          @click="dialog = false"
          style="border-radius: 6px"
        >
          <span class="font-size--16 font-weight-bold white--text"> 확인 </span>
        </BasicButton>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      dialog: false,
    }
  },

  watch: {
    availableAmount: {
      handler({ status }) {
        if (status && ['rejected'].includes(status)) {
          this.dialog = true
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState('bnpl', ['availableAmount']),
  },
}
</script>
